import { LeftArrow, RightArrow } from './Arrows';
import React, { useEffect, useRef } from 'react';
import useScreenType from '../../../hooks/utility/useScreenType';
import { ScrollMenu as BasicScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import classnames from 'classnames';
import useMobileApp from '../../../hooks/mobile-app/useMobileApp';

type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

interface Props {
  children: any;
  focusedCategoryId: null | number;
}

export default function ScrollMenu(props: Props) {
  const { children, focusedCategoryId } = props;

  const { isDesktop: fullScreen } = useScreenType();
  const { isMobileApp } = useMobileApp();

  const apiRef = useRef({} as scrollVisibilityApiType);

  useEffect(() => {
    setTimeout(() => {
      apiRef.current?.scrollToItem?.(apiRef.current?.getItemElementById(focusedCategoryId), 'smooth', 'start');
    });
  }, [focusedCategoryId]);

  function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
    const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isTouchpad) {
      ev.stopPropagation();

      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  return (
    <BasicScrollMenu
      onWheel={onWheel}
      apiRef={apiRef}
      LeftArrow={
        fullScreen ? (
          <div className="flex items-center" onClick={() => apiRef.current.scrollPrev()}>
            <LeftArrow />
          </div>
        ) : (
          <div
            className={classnames({
              'px-[4px]': isMobileApp,
            })}
          />
        )
      }
      RightArrow={
        fullScreen ? (
          <div className="flex items-center" onClick={() => apiRef.current.scrollNext()}>
            <RightArrow />
          </div>
        ) : null
      }
      wrapperClassName="w-full overflow-auto"
      scrollContainerClassName="scrollbar-hide lg:pl-sm gap-2xs"
    >
      {children}
    </BasicScrollMenu>
  );
}
